import React, {createRef} from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Collapse
} from "reactstrap";
import { get_data_transport_trace, get_permission } from "network/ApiAxios";
import {PutContent, PutContentSub, PutContentSubTwo, PutContentStatus, PutContentSubPlant} from './InfoLogistic'
import ModalObservation from './ModalObservationMRV'
import NotificationAlert from "react-notification-alert";
import DetailsObservationsRev from "views/pages/examples/Production_FV/DetailProductionTime/DetailsObservationsRev";
import jQuery from 'jquery'

export default class ContentLogistic extends React.Component {
  state = {
    notificationAlertRef: React.createRef(),
    cross_transport:['cargando'],
    openColapse:[false],
    openColapseChild:[false],
    openColapseNextChild:[false],
    set_type_content:{},
    set_type_content_onre:null,
    data_user:null,
    db_prod:new URLSearchParams(window.location.search).get("db"),
    code_prod:new URLSearchParams(window.location.search).get("code"),
    form_prod:null,
    put_table:null,
    type_traza_data_user:this.props.dataRow.data_user_ad
  }
  async componentDidMount(){
    var userdata = localStorage.getItem('user');
    var jsondata = JSON.parse(userdata);
    // var dataPermission = await get_permission(jsondata._id)
    // this.setState({data_user:dataPermission})
    this.setState({data_user:this.props.dataRow.get_data_user,type_traza_data_user:this.props.dataRow.data_user_ad})
  }
  contentRows = () =>{

    var content = []
    this.props.dataTable.map((val,indx)=>{
      content[indx] = <>
            <Col md={12}>
            <div className="elementor-widget-wrap elementor-element-populated">
            <div style={{marginBottom:'0px'}} className="elementor-element elementor-element-5247922 elementor-widget elementor-widget-toggle" data-id="5247922" data-element_type="widget" data-widget_type="toggle.default">
            <div className="elementor-widget-container">
            <div role="tablist">
            <div className="elementor-toggle-item" style={{zIndex: '99'}}>
            <h6 onClick={(e)=>{
              if (this.props.dataRow.get_data_user!=null) {
                if (this.state.type_traza_data_user=='VA') {
                  this.funcOpenModal(true,'validar',val.table,val.title)
                }
                if (this.state.type_traza_data_user=='ON' || this.state.type_traza_data_user=='RE') {
                  this.funcOpenModal(true,'general',val.table,val.title)
                }
              }
              this.opened(this.state.openColapse[indx+1],indx+1,val.table)
            }} id={val.table} className="elementor-tab-title clk_change_table" data-tab="1" role="tab" aria-controls="elementor-tab-content-8621" aria-expanded="false">
              <div style={{marginBottom:'10px'}} className="elementor-element elementor-element-d816072 elementor-position-left elementor-vertical-align-middle elementor-widget elementor-widget-image-box" data-id="d816072" data-element_type="widget" data-widget_type="image-box.default">
              <div className="elementor-widget-container">
              <div className="elementor-image-box-wrapper">
              <figure className="elementor-image-box-img">
              <div style={{width:30,height:30,backgroundColor:PutContentStatus(this.props.dataRow.allDataTrza,val.table).color,borderRadius: '100px', textAlign: 'center'}}>
              <span className={val.icon} style={{color:'#204d74',fontSize: '23px',position: 'relative',bottom: '0px',left: '0px'}}></span>
              </div>
              </figure>
              <div className="elementor-image-box-content">
              <span className="eael-tab-title title-after-icon" style={{fontWeight: 'normal',fontSize: '12px'}}>{val.title}</span>
              </div>
              </div>
              </div>
              </div>
            </h6>
                  <Row>
{/*                    <Col md={12}>
                      <button className="btn" onClick={()=>{  }}>{(this.state.set_type_content[val.table]==undefined)?('Agregar Observación / Recomendación'):(
                        (this.state.set_type_content[val.table]==1)?('Agregar Observación / Recomendación'):('Ocultar Información')
                        )}</button>
                    </Col>*/}
{/*                    {(this.props.dataRow.get_data_user!=null)?((this.state.type_traza_data_user=='VA')?(
                      <Col md={12}>
                        <button className="btn" onClick={()=>{this.funcOpenModal(true,'validar',val.table,val.title)}}>{(this.state.set_type_content[val.table]==undefined)?('Validar / Certificar Información'):(
                        (this.state.set_type_content[val.table]==1)?('Validar / Certificar Información'):('Ocultar Información')
                        )}</button>
                      </Col>
                    ):(null)):(null)}*/}
                  </Row>
                </div>
                </div>
                </div>
                </div>
                <div className="elementor-element elementor-element-81e561d elementor-widget elementor-widget-spacer" data-id="81e561d" data-element_type="widget" data-widget_type="spacer.default">
                <div className="elementor-widget-container">
                  <div className="elementor-spacer">
            </div>
            </div>
            </div>
            </div>
        </Col>
                  </>
    })
    return content
  }
  contentRowsCard = () =>{
    var content = []
    this.props.dataTable.map((val,indx)=>{
      content[indx] = <>
      {(this.props.dataRow.allDataTrza[val.table]==undefined)?(null):(
            <div style={{marginBottom:'0px'}} className="elementor-element elementor-element-5247922 elementor-widget elementor-widget-toggle">
            <div className="elementor-widget-container">
            <div className="elementor-toggle" role="tablist">
            <div className="elementor-toggle-item">
            <Collapse isOpen={this.state.openColapse[indx+1]} id="elementor-tab-content-6961" className="elementor-clearfix" data-tab="1" role="tabpanel" aria-labelledby="elementor-tab-title-6961">
              <ul style={{padding: '0px'}}>
            {(val.multiple_tables==0)?(<>
              {(this.props.dataRow.allDataTrza[val.table]['data_array'].length>1)?(
                      <PutContentSub
                      data_function={this.props.dataRow} 
                      type_function={val.table}
                      states={this.state}
                      openedChild={this.openedChild}
                      chillSelector={"data"}
                      />
                ):(
                  <div style={{margin: 'auto'}}>
                    <Card className="p-0">
                      <CardHeader style={{padding: '10px',backgroundColor: 'rgb(122, 193, 66)'}}>
                      <Row>
                        <Col md={1}>
                          <h4 className="mb-0" style={{color: '#ffffff',fontSize: '11px'}}>Estado:</h4>
                        </Col>
                        <div>
                          <h4 className={"mb-0 verifyRegister_"+val.table} style={{color: '#ffffff',fontSize: '11px'}}>{PutContentStatus(this.props.dataRow.allDataTrza,val.table).register_status}</h4>
                        </div>
                      </Row>
                      </CardHeader>
                      <CardBody>
                        <Row>
                        <PutContent 
                        data_function={this.props.dataRow} 
                        type_function={val.table} />                  
                        </Row>
                      </CardBody>
                    </Card>
                  </div>
                )}
              </>):(null)}
            {(val.multiple_tables==1)?(<>
              <PutContentSubTwo
              data_function={this.props.dataRow} 
              type_function={val.table_one}
              type_function_two={val.table_two}
              states={this.state}
              openedChild={this.openedChild}
              openedNextChild={this.openedNextChild}
              chillSelector={"datat"}
              titleType={val.title_one}
              titleTypeTwo={val.title_two}
              />
              </>):(null)}
            {(val.multiple_tables==2)?(<>
              <PutContentSubPlant
              data_function={this.props.dataRow} 
              type_function={val.table_one}
              type_function_two={val.table_two}
              type_function_tree={val.table_three}
              type_function_four={val.table_fuor}
              states={this.state}
              openedChild={this.openedChild}
              openedNextChild={this.openedNextChild}
              chillSelector={"datadp"}
              titleType={val.title_one}
              titleTypeTwo={val.title_two}
              titleTypeTree={val.title_three}
              titleTypeFour={val.title_fuor}
              />
              </>):(null)}
              </ul>
              </Collapse>
            </div>
            </div>
            </div>
            </div>
            )}

                  </>
    })
    return content
  }
   opened = (isChange,ident,element) =>{
      if (isChange==undefined) {
      this.setState({openColapse:{[ident]: true }});
      }else{
      this.setState({openColapse:{[ident]: !isChange }});
      }
        jQuery('.clk_change_table').css({'background-color':'transparent', 'color': '#204D74', 'border-radius': '5px'})
        var elementForStyleParent = jQuery('#'+element)
          elementForStyleParent.css({'background-color':'#2d5980', 'color': 'white', 'border-radius': '5px'})
        // if (elementForStyleParent[0].tagName=='DIV') {
        //   var elementForStyle = elementForStyleParent.parent().css('background-color','#2d5980')
        // }else{
        //   var elementForStyle = elementForStyleParent.css('background-color','#2d5980')
        // }
    }
   // openedChild = (isChange,ident) =>{
   //    if (isChange==undefined) {
   //      this.setState({openColapseChild:{[ident]: true }});
   //      }else{
   //      this.setState({openColapseChild:{[ident]: !isChange }});
   //      }
   //    }
     openedChild = (isChange,ident,valuePut,id_register) =>{
  var put_title_activity
    if (this.state.type_traza_data_user=='ON') {
      put_title_activity = this.state.put_title_g+' - '+valuePut+' * '+id_register
    }
    if (this.state.type_traza_data_user=='RE') {
      put_title_activity = this.state.put_title_g+' - '+valuePut+' * '+id_register
    }
    if (this.state.type_traza_data_user=='VA') {
      put_title_activity = this.state.put_title_g+' - '+valuePut+' * '+id_register
    }
      if (isChange==undefined) {
        this.setState({openColapseChild:{[ident]: true }});
        }else{
        this.setState({openColapseChild:{[ident]: !isChange }});
        }
        this.setState({put_title:put_title_activity})
      }
     openedNextChild = (isChange,ident) =>{
     if (isChange==undefined) {
       this.setState({openColapseNextChild:{[ident]: true }});
       }else{
       this.setState({openColapseNextChild:{[ident]: !isChange }});
       }
     }
     setTransport = async (value, index,ident) =>{ 
       this.setState({cross_transport:[{numero_de_guia:'Cargando'}]})
       var data_transport = await get_data_transport_trace(value)
       this.setState({cross_transport:data_transport})
     }
 funcOpenModal = (chan,form,put_table,put_title) =>{
  var id_register = jQuery('.get_info_register_'+put_table).attr('id-register')
  var put_id_register = ''
  if (id_register!=undefined) {
    put_id_register = ' * '+id_register
  }
  var put_title_activity
    if (this.state.type_traza_data_user=='ON') {
      put_title_activity = "Monitoreo de "+put_title+put_id_register
    }
    if (this.state.type_traza_data_user=='RE') {
      put_title_activity = "Revisión de "+put_title+put_id_register
    }
    if (this.state.type_traza_data_user=='VA') {
      put_title_activity = "Validación de "+put_title+put_id_register
    }
    this.setState({
      openModal:chan,
      // db_prod:this.state.routegetThree,
      // code_prod:this.state.routeget,
      form_prod:form,
      put_table:put_table,
      put_title:put_title_activity,
      put_title_g:put_title_activity
    })
    if (this.state.set_type_content[put_table]==undefined) {
      this.setState({set_type_content: {[put_table]:2} })
    }else{    
      if (this.state.set_type_content[put_table]==1) {
        this.setState({set_type_content: {[put_table]:2} })
      }else{
        this.setState({set_type_content:{[put_table]:1}})
      }
    }
  }
funcObs = async (chan,type_user_role) =>{
    var type_user_p=null
    if (this.props.dataRow.get_data_user!=null) {
     type_user_p = this.state.type_traza_data_user
    }
    if (this.state.set_type_content_onre==type_user_role) {
      this.setState({set_type_content_onre:null})  
    }else{
      this.setState({set_type_content_onre:type_user_role})      
    }
}
  render(){
    const notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">
            {message}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 10,
    };
    this.state.notificationAlertRef.current.notificationAlert(options);
  };
  const insertDataObservation = async () =>{
       notify("success", "¡Registrado exitosamente!", 'Se guardo exitosamente.');
  }
  return (
    <>
                    <div className="rna-wrapper">
                      <NotificationAlert ref={this.state.notificationAlertRef} />
                    </div>

                      <Row>
                      <Col md={2} style={{left:'0%'}} className="mt-2">
                    {(this.props.dataRow.get_data_user!=null)?(
                      (this.state.type_traza_data_user=='RE' || this.state.type_traza_data_user=='VA')?(
                                                  <Col md={12}>
                                                    <button className="btn" onClick={()=>{this.funcObs(true,'ON')}}>{(this.state.set_type_content_onre!="ON")?('Ver Observaciones de Monitoreo'):('Ocultar Información')}</button>
                                                  </Col>
                                              ):(null)
                    ):(null)}
                    {(this.props.dataRow.get_data_user!=null)?((this.state.type_traza_data_user=='VA')?(
                      <Col md={12}>
                        <button className="btn" onClick={()=>{this.funcObs(true,'RE')}}>{(this.state.set_type_content_onre!="RE")?('Ver Observaciones de Revisión'):('Ocultar Información')}</button>
                      </Col>
                    ):(null)):(null)}
                      {this.contentRows()}
                      </Col>
                      <Col md={10} className="pt-2">
                      {(this.state.set_type_content_onre==null)?(null):(
                            (this.state.set_type_content_onre=='ON' || this.state.set_type_content_onre=='RE')?(
                              <DetailsObservationsRev thisStates={this.state} />
                            ):(null)
                          )}
                      {this.contentRowsCard()}
                      {(this.state.set_type_content[this.state.put_table]==undefined)?(null):(
                        (this.state.set_type_content[this.state.put_table]==1)?(null):(
                          (jQuery(".verifyRegister_"+this.state.put_table).text().indexOf('Sin Registro')==-1)?(
                              <>
                              {(this.state.type_traza_data_user=='VA')?(null):(
                                <ModalObservation thisStates={this.state} sendOpenModal={this.state.openModal} openModalFunc={this.funcOpenModal} insertDataObservation={insertDataObservation}/>
                                )}
                              </>
                            ):(null)
                          )
                        )}
                      </Col>
                      </Row>

    </>
  );
}
}